import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { on } from 'delegated-events'

gsap.registerPlugin(ScrollTrigger)

const productSelector = document.querySelector('.product-selector')
const productSelectorTitles = document.querySelector('.product-selector-titles')
const productSelectorImages = document.querySelector('.product-selector-images')
const initialId = productSelector?.dataset.selected

const fn = {
  init: () => {
    fn.setupProductSelector()
    fn.setupStoreSearch()
    fn.setupVariants()
    fn.setupAnimations()
  },

  setupProductSelector: () => {
    on('mouseover', '.product-selector-dot', (e) => {
      const anchor = e.target.closest('a')
      const image = productSelectorImages.querySelector(`[data-id="${anchor.dataset.id}"]`)
      const title = productSelectorTitles.querySelector(`[data-id="${anchor.dataset.id}"]`)
      const initialDot = document.querySelector('.product-selector-dot.is-initial')

      fn.clearActiveProductSelector()

      if (anchor && !image.classList.contains('is-active')) {
        image.classList.add('is-active')
      }

      if (anchor && !title.classList.contains('is-active')) {
        title.classList.add('is-active')
      }

      if (initialDot !== e.target) {
        initialDot.classList.remove('is-active')
      }
    })

    on('mouseout', '.product-selector-dot', () => {
      fn.clearActiveProductSelector()
      fn.activateInitial()
    })

    fn.drawProductSelector()
    fn.activateInitial(initialId)
  },

  clearActiveProductSelector: () => {
    const productSelectorTitles = document.querySelector('.product-selector-titles')
    const activeTitle = productSelectorTitles.querySelector('.is-active')
    const productSelectorImages = document.querySelector('.product-selector-images')
    const activeImage = productSelectorImages.querySelector('.is-active')

    if (activeTitle) {
      activeTitle.classList.remove('is-active')
    }

    if (activeImage) {
      activeImage.classList.remove('is-active')
    }
  },

  activateInitial: () => {
    const initialDot = productSelector.querySelector(`.product-selector-dot[data-id="${initialId}"]`)
    const initialImage = productSelectorImages.querySelector(`[data-id="${initialId}"]`)
    const initialTitle = productSelectorTitles.querySelector(`[data-id="${initialId}"]`)

    if (initialDot) {
      initialDot.classList.add('is-active')
    }

    if (initialImage) {
      initialImage.classList.add('is-active')
    }

    if (initialTitle) {
      initialTitle.classList.add('is-active')
    }
  },

  drawProductSelector: () => {
    const circle = productSelector.querySelector('.product-selector-circle')
    const dots = productSelector.querySelectorAll('.product-selector-dot')
    const width = circle.getBoundingClientRect().width
    const height = circle.getBoundingClientRect().height
    const radius = Math.floor(width / 2)
    let angle = 0
    const step = (2 * Math.PI) / dots.length

    dots.forEach((dot, i) => {
      const x = Math.round(width / 2 + radius * Math.cos(angle) - dot.getBoundingClientRect().width / 2)
      const y = Math.round(height / 2 + radius * Math.sin(angle) - dot.getBoundingClientRect().height / 2)

      dot.style.left = `${x}px`
      dot.style.top = `${y}px`
      dot.querySelector('.inner').style.transitionDelay = `${i * 50}ms`

      angle += step
    })

    dots.forEach((dot) => {
      dot.querySelector('.inner').classList.add('is-init')
    })
  },

  setupStoreSearch: () => {
    const form = document.getElementById('product-store-form')
    const map = document.getElementById('store-map')

    if (form && map) {
      on('submit', '#product-store-form', (e) => {
        e.preventDefault()

        const zip = form.querySelector('input[name=zip]').value

        form.reset()

        map.classList.remove('opacity-0')
        map.classList.remove('pointer-events-none')
        document.documentElement.classList.add('overflow-hidden')

        const zipField = map.querySelector('#storepoint-searchbar')

        if (zipField) {
          const form = zipField.closest('form')

          setTimeout(() => {
            zipField.value = zip
          }, 500)
        }
      })
    }
  },

  setupVariants: () => {
    on('click', '.product-variant-toggle', (e) => {
      const target = e.target.dataset.target

      document.querySelectorAll('.product-variant-toggle.is-active').forEach((x) => x.classList.remove('is-active'))
      e.target.classList.add('is-active')

      const highlights = document.querySelector(`#highlights-${target}`)

      if (highlights) {
        document.querySelectorAll('.product-variant-highlights').forEach((x) => x.classList.add('hidden'))
        highlights.classList.remove('hidden')
      }

      const nutrition = document.querySelector(`#nutrition-${target}`)

      if (nutrition) {
        document.querySelectorAll('.product-variant-nutrition').forEach((x) => x.classList.add('hidden'))
        nutrition.classList.remove('hidden')
      }
    })
  },

  setupAnimations: () => {
    const detailImage = document.querySelector('.product-detail-image')
    const detailIngredientImage = document.querySelector('.product-detail-ingredient-image')

    if (detailImage) {
      const detailImageTimeline = gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: detailImage,
        },
      })

      detailImageTimeline.fromTo(detailImage, { translateX: '100%' }, { translateX: 0, duration: 0.75, ease: 'back' })

      if (detailIngredientImage) {
        detailImageTimeline.fromTo(detailIngredientImage, { translateX: '100%' }, { translateX: 0 })
      }
    }
  },
}

export default {
  can: () => document.body.classList.contains('products-detail-page'),
  run: fn.init,
}
